module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/babel-runtime/core-js/object/keys.js
// module id = 732
// module chunks = 0